(function ($) {
	// Initialize Swiper for related products when document is ready
	$(document).ready(function () {
		// Handle sort selector change event
		$("#ttg-sort-select").on("change", function () {
			const sortVal = $(this).val();

			// Get current URL and update or add the sort parameter
			const currentUrl = new URL(window.location.href);
			currentUrl.searchParams.set("sort", sortVal);

			// Navigate to the new URL with the sort parameter
			window.location.href = currentUrl.toString();
		});

		// Handle filter toggle functionality
		const $wrapperFilter = $(".wrapper-filter");
		const $toggleFilter = $(".toogle-filter");
		const $closeFilter = $(".wrapper-filter__close");

		// Hide filter wrapper initially
		$wrapperFilter.css({
			left: "-100%",
			position: "fixed",
			top: "0",
			height: "100%",
			"z-index": "999",
			"background-color": "#fff",
			width: "300px",
			transition: "left 0.3s ease-in-out",
			"box-shadow": "0 0 15px rgba(0, 0, 0, 0.1)",
			"overflow-y": "auto",
		});

		// Toggle filter when clicking the filter button
		$toggleFilter.on("click", function () {
			$wrapperFilter.css("left", "0");
			$("body").addClass("filter-open").css("overflow", "hidden");
		});

		// Close filter when clicking the close button
		$closeFilter.on("click", function () {
			$wrapperFilter.css("left", "-100%");
			$("body").removeClass("filter-open").css("overflow", "");
		});

		// Close filter when clicking outside
		$(document).on("mouseup", function (e) {
			if (
				!$wrapperFilter.is(e.target) &&
				$wrapperFilter.has(e.target).length === 0 &&
				!$toggleFilter.is(e.target) &&
				$toggleFilter.has(e.target).length === 0
			) {
				$wrapperFilter.css("left", "-100%");
				$("body").removeClass("filter-open").css("overflow", "");
			}
		});

		// Handle layout switching (grid/list) functionality
		$(".single-registry__layout button").on("click", function () {
			const $this = $(this);
			const layout = $this.data("layout");

			// Remove active class from all buttons and add it to the clicked one
			$(".single-registry__layout button").removeClass("active");
			$this.addClass("active");

			// Update the product list layout class
			const $productList = $(".product-list");
			$productList.removeClass("layout--grid layout--list");
			$productList.addClass(layout);
		});

		// Initialize facet groups
		function initFacetGroups() {
			// Setup all facet groups with proper attributes
			$(".facet-group").each(function (index) {
				const $group = $(this);
				const $label = $group.find(".facet-label");
				const $content = $group.find(".facetwp-facet");
				const groupId = "facet-group-" + index;

				// Add accessibility attributes if they don't exist
				if (!$label.attr("role")) {
					$label.attr({
						role: "button",
						tabindex: "0",
					});
				}

				// Make sure each facet has a unique ID for aria-controls
				if (!$content.attr("id")) {
					$content.attr("id", groupId + "-content");
					$label.attr("aria-controls", groupId + "-content");
				}

				// Set first group as active, others as inactive
				// if (index === 0) {
				//     $group.addClass('facet-group--active');
				//     $label.addClass('facet-label--active');
				//     $label.attr('aria-expanded', 'true');
				// } else {
				$content.hide();
				$label.attr("aria-expanded", "false");
				// }
			});
		}

		// Call initialization on page load
		initFacetGroups();

		// Toggle facet content when clicking on facet label
		$(document).on("click", ".facet-label", function () {
			toggleFacetGroup($(this));
		});

		// Handle keyboard accessibility
		$(document).on("keydown", ".facet-label", function (e) {
			// If Enter or Space key is pressed
			if (e.which === 13 || e.which === 32) {
				e.preventDefault();
				toggleFacetGroup($(this));
			}
		});

		// Function to toggle facet group visibility
		function toggleFacetGroup($label) {
			const $facetGroup = $label.closest(".facet-group");
			const $facetContent = $facetGroup.find(".facetwp-facet");

			// Toggle the facet content with slide animation
			$facetContent.slideToggle(300);

			// Toggle active class on the facet group for styling
			$facetGroup.toggleClass("facet-group--active");

			// Toggle active class on the label for styling
			$label.toggleClass("facet-label--active");

			// Update WAI-ARIA attributes for accessibility
			const isExpanded = $label.hasClass("facet-label--active");
			$label.attr("aria-expanded", isExpanded);
		}

		// Infinite scroll for FacetWP load-more facet
		(function initFacetInfiniteScroll() {
			let observer = null;

			function observe() {
				const btn = document.querySelector(".facetwp-load-more");
				if (!btn) return;

				if (observer) observer.disconnect();

				observer = new IntersectionObserver(
					function (entries) {
						entries.forEach(function (entry) {
							if (
								entry.isIntersecting &&
								!btn.classList.contains("disabled") &&
								btn.style.display !== "none"
							) {
								btn.click();
							}
						});
					},
					{ rootMargin: "0px 0px 200px 0px" },
				);

				observer.observe(btn);
			}

			// Re-attach after every FacetWP refresh (new button may be rendered)
			document.addEventListener("facetwp-loaded", observe);

			// Initial attach
			observe();
		})();

		if (typeof Swiper === "undefined") {
			// console.error('Swiper is not loaded.');
			return;
		} else {
			const swiper = new Swiper(".swiper-related", {
				// centeredSlides: true,
				loop: false,
				speed: 500,
				effect: "slide",
				autoHeight: false,
				spaceBetween: 24,
				initialSlide: 4, // Start at the 5th slide (index 4)
				// slideActiveClass: 'swiper-slide-active',
				navigation: {
					nextEl: ".ttg-our-bromberg__button-next",
					prevEl: ".ttg-our-bromberg__button-prev",
				},
				// Add responsive breakpoints
				breakpoints: {
					// when window width is <= 768px
					1200: {
						slidesPerView: 4,
					},
					769: {
						slidesPerView: 3,
					},
					// when window width is <= 480px
					320: {
						slidesPerView: 1,
					},
				},
			});

			// Variable to store recently viewed products swiper instance
			let recentlyViewedSwiper = null;

			// Function to initialize recently viewed products swiper
			function initRecentlyViewedSwiper() {
				if (window.innerWidth <= 1200) {
					if (!recentlyViewedSwiper) {
						recentlyViewedSwiper = new Swiper(
							".swipper-recently-viewed-products",
							{
								loop: false,
								speed: 500,
								effect: "slide",
								autoHeight: false,
								spaceBetween: 24,
								slidesPerView: 1,
								initialSlide: 2,
								navigation: {
									nextEl: ".ttg-our-bromberg__button-next",
									prevEl: ".ttg-our-bromberg__button-prev",
								},
								// Add responsive breakpoints
								breakpoints: {
									769: {
										slidesPerView: 3,
									},
									// when window width is <= 480px
									320: {
										slidesPerView: 1,
									},
								},
							},
						);
					}
				} else if (recentlyViewedSwiper) {
					// Destroy swiper if screen size is larger than 1200px
					recentlyViewedSwiper.destroy(true, true);
					recentlyViewedSwiper = null;
				}
			}

			// Initialize swiper on page load
			initRecentlyViewedSwiper();

			// Re-initialize on window resize
			$(window).on("resize", function () {
				initRecentlyViewedSwiper();
			});
		}
	});

	$(".wishlist-header__tab__menu a").on("click", function (e) {
		e.preventDefault();
		const target = $(this).attr("href");

		// Remove active class from all tabs and add to the clicked one
		$(".wishlist-header__tab__menu li").removeClass("active");
		$(this).parent().addClass("active");

		// Hide all content items and show the targeted one
		$(".wishlist-header__tab__content__item").removeClass("active");
		$(target).addClass("active");
	});
	$(".view-collection-btn").on("click", function (e) {
		e.preventDefault();
		const target = $(this).attr("href");
		$(target).addClass("active");
	});
	$(".wishlist-gallery__close").on("click", function (e) {
		e.preventDefault();
		$(this).closest(".wishlist-gallery").removeClass("active");
	});

	function checkUserLoggedIn(href = null) {
		if ($("body").hasClass("logged-in")) {
			if (href) {
				window.location.href = href;
			} else {
				window.location.href = "/account";
			}
			return;
		}
		$(".js-login-popup-toggle").trigger("click");
	}

	$(".js-check-login").on("click", function (e) {
		e.preventDefault();
		checkUserLoggedIn();
	});

	$("a[href*='account']").on("click", function (e) {
		const href = $(this).attr("href");
		e.preventDefault();
		checkUserLoggedIn(href);
	});
})(jQuery);
